import { default as ProfileDetailsPage } from './profile-details';
export default { ProfileDetailsPage }